<fgb-page-header [pageTitle]="'nav.loaded.tickets'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'nav.loaded.tickets' | translate"></fgb-banner>

<div class="container">
  <!-- Change Event Section -->
  <h5 class="text-uppercase title mb-1 text-primary">{{ 'loaded.tickets.page.title' | translate }}</h5>
  <p class="font-size-14 text-primary">{{ 'loaded.tickets.page.desc' | translate }}</p>

  @if (loadingEvents()) {
    <div class="card placeholder-card" aria-hidden="true">
      <div class="card-body p-0">
        <div class="card-text placeholder-glow">
          <span class="placeholder col-12"></span>
        </div>
      </div>
    </div>
  } @else if (selectedEvent()) {
    <fgb-selected-event></fgb-selected-event>

    <fgb-tickets></fgb-tickets>
  } @else {
    <div class="">
      <div class="placeholder-box font-size-12 text-center border bg-white text-black py-3">
        {{ 'no.events.placeholder' | translate }}
      </div>
    </div>
  }
</div>
